export const createDefaultSiteSettings = () => ({
  key: "primary",
  site_name: "Zetech University",
  site_tagline: "Innovation, Excellence, Impact",
  contact_email: "info@zetech.ac.ke",
  support_phone: "+254 700 000 000",
  default_timezone: "Africa/Nairobi",
  maintenance_mode: false,
  enable_comments: true,
  enable_email_notifications: true,
  logo_url: "",
  primary_color: "#0F4C81",
  secondary_color: "#F4B400",
  social_links: {
    facebook: "",
    twitter: "",
    linkedin: "",
    instagram: "",
    youtube: "",
    tiktok: "",
  },
});

export const buildSiteSettingsPayload = (values) => ({
  key: values.key || "primary",
  site_name: values.site_name || "",
  site_tagline: values.site_tagline || "",
  contact_email: values.contact_email || "",
  support_phone: values.support_phone || "",
  default_timezone: values.default_timezone || "Africa/Nairobi",
  maintenance_mode: Boolean(values.maintenance_mode),
  enable_comments: Boolean(values.enable_comments),
  enable_email_notifications: Boolean(values.enable_email_notifications),
  logo_url: values.logo_url || "",
  primary_color: values.primary_color || "#0F4C81",
  secondary_color: values.secondary_color || "#F4B400",
  social_links: values.social_links || {},
});
